<template>
  <div>
    <b-alert variant="danger"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          ADP Download Test
        </div>
        <!-- User Interface controls -->
        <b-row>
          <b-col md="6" class="my-0">
            <b-form-group class="my-1">
              <b-input-group v-on:keyup.enter="DownloadInventory">
                <b-form-input v-model="tbxAccountNumber" placeholder="Type an account number" />
                <b-input-group-append>
                  <b-btn class="btn btn-success text-white ml-2" @click="ViewInventory" :disabled="!CanDoTest">
                    <i class="fa fa-download" title="View Inventory"></i> <strong class="text-white">View Inventory</strong>
                  </b-btn>
                </b-input-group-append>
                <b-input-group-append>
                  <b-btn class="btn btn-success text-white ml-2" @click="DownloadInventory" :disabled="!CanDoTest">
                    <i class="fa fa-download" title="Download Inventory"></i> <strong class="text-white">Download Inventory</strong>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <div v-if="CanSeeResult">
          <b-row>
            <b-col md="12" class="my-0">
              <span><strong>Inventory:</strong></span>
            </b-col>
          </b-row>
          <b-row v-if="serverText.length > 0">
            <b-col md="12" class="my-0">
              <div v-html="serverText"></div>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col md="12" class="my-0">
              <span>There are no records to show</span>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import moment from 'moment'
import { setTimeout } from 'timers'

export default {
  components: {
    loading
  },
  data () {
    let accNumber = localStorage.getItem('ADPDownloadTestvueFilter')
    if (accNumber === null || accNumber === 'null' || accNumber === 'undefined') {
      accNumber = undefined
    }
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      txtLoading: 'Loading...',
      boolLoading: false,
      tbxAccountNumber: accNumber,
      serverText: undefined
    }
  },
  created () {
    let self = this
    setTimeout(function () {
      self.boolLoading = false
    }, 0)
  },
  methods: {
    DownloadInventory () {
      let self = this
      self.boolLoading = true

      let data = {
        'accountNumber': self.tbxAccountNumber
      }

      axios.post('/api/ADPDownload/DownloadCSVFile', data)
        .then(response => {
          self.showDismissibleAlert = false;
          self.errMsg = '';

          const a = document.createElement("a");
          a.style.display = "none";
          document.body.appendChild(a);

          // Set the HREF to a Blob representation of the data to be downloaded
          var MIME_TYPE = "text/csv";
          a.href = window.URL.createObjectURL(
            new Blob([response.data], { type: MIME_TYPE })
          );

          // Use download attribute to set set desired file name
          var fileName = self.tbxAccountNumber +".csv";
          a.setAttribute("download", fileName);

          // Trigger the download by simulating click
          a.click();

          // Cleanup
          window.URL.revokeObjectURL(a.href);
          document.body.removeChild(a);


          //self.showDismissibleAlert = false;
          //var MIME_TYPE = "text/csv";
          //var blob = new Blob([response.data], {type: MIME_TYPE});
          //window.location.href = window.URL.createObjectURL(blob);
        })
        .catch(error => {
          if (error !== undefined && error.response !== undefined && error.response.status === 403) {
            self.$router.push('/login')
          }
          self.errMsg = 'There was an error getting data : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
          self.showDismissibleAlert = true
        }).then(response => {
          self.boolLoading = false;
        })
    },
    ViewInventory () {
      let self = this
      self.boolLoading = true

      let data = {
        'accountNumber': self.tbxAccountNumber
      }

      axios.post('/api/ADPDownload/Test', data)
        .then(response => {
          self.errMsg = ''
          self.showDismissibleAlert = false
          if (typeof (response.data) === 'object') {
            self.serverText = JSON.stringify(response.data)
          } else {
            self.serverText = (response.data + '').replace(/\r\n/gi, '<br />')
          }
        })
        .catch(error => {
          if (error !== undefined && error.response !== undefined && error.response.status === 403) {
            self.$router.push('/login')
          }
          self.errMsg = 'There was an error getting data : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
          self.showDismissibleAlert = true
        }).then(response => {
          self.boolLoading = false
        })
    }
  },
  filters: {
    formatDate: function (date) {
      let m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    },
    formatDateToNow: function (date) {
      let m = moment(date)
      if (m.isValid()) {
        let localTime = m.add(moment().utcOffset(), 'm')
        return localTime.toNow(true) + ' ago'
      }
      return ''
    }
  },
  watch: {
    tbxAccountNumber: function (val) {
      if (val === null || val === 'null' || val === 'undefined') {
        val = undefined
      }
      localStorage.setItem('ADPDownloadTestvueFilter', val)
    }
  },
  computed: {
    CanDoTest: function () {
      let self = this
      if (self.tbxAccountNumber !== undefined && self.tbxAccountNumber !== null && self.tbxAccountNumber.length > 0) {
        return true
      }
      return false
    },
    CanSeeResult: function () {
      let self = this
      if (self.serverText !== undefined && self.serverText !== null) {
        return true
      }
      return false
    }
  },
  mounted () {
    let self = this
    self.boolLoading = true
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ADPDownloadTest.vue